export enum ApiType {
    Internal = 'Internal',
    InAzure = 'InAzure',
    InApir = 'InApir',
    ExternalInApir = 'ExternalApir',
    ExternalAzure = 'ExternalAzure',
    External = 'External'
}
